// Shared react-select styles that follow the active Bootstrap theme (data-bs-theme).
// Every color resolves to a Bootstrap CSS variable, so menus/controls/options adapt
// to light and dark mode automatically instead of react-select's hardcoded white.
export const themedSelectStyles = {
    control: (base, state) => ({
        ...base,
        backgroundColor: 'var(--bs-body-bg)',
        borderColor: state.isFocused ? 'var(--bs-primary)' : 'var(--bs-border-color)',
        boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(var(--bs-primary-rgb), 0.25)' : 'none',
        color: 'var(--bs-body-color)',
        '&:hover': { borderColor: 'var(--bs-primary)' },
    }),
    menu: (base) => ({
        ...base,
        backgroundColor: 'var(--bs-body-bg)',
        border: '1px solid var(--bs-border-color)',
        zIndex: 6,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? 'var(--bs-primary)'
            : state.isFocused
                ? 'var(--bs-tertiary-bg)'
                : 'transparent',
        color: state.isSelected ? '#fff' : 'var(--bs-body-color)',
        cursor: 'pointer',
        '&:active': { backgroundColor: 'var(--bs-secondary-bg)' },
    }),
    singleValue: (base) => ({ ...base, color: 'var(--bs-body-color)' }),
    multiValue: (base) => ({ ...base, backgroundColor: 'var(--bs-secondary-bg)' }),
    multiValueLabel: (base) => ({ ...base, color: 'var(--bs-body-color)' }),
    multiValueRemove: (base) => ({
        ...base,
        color: 'var(--bs-body-color)',
        ':hover': { backgroundColor: 'var(--bs-danger)', color: '#fff' },
    }),
    input: (base) => ({ ...base, color: 'var(--bs-body-color)' }),
    placeholder: (base) => ({ ...base, color: 'var(--bs-secondary-color)' }),
    groupHeading: (base) => ({ ...base, color: 'var(--bs-secondary-color)' }),
    indicatorSeparator: (base) => ({ ...base, backgroundColor: 'var(--bs-border-color)' }),
    dropdownIndicator: (base) => ({
        ...base,
        color: 'var(--bs-secondary-color)',
        ':hover': { color: 'var(--bs-body-color)' },
    }),
    clearIndicator: (base) => ({
        ...base,
        color: 'var(--bs-secondary-color)',
        ':hover': { color: 'var(--bs-danger)' },
    }),
    noOptionsMessage: (base) => ({ ...base, color: 'var(--bs-secondary-color)' }),
};
